
import { Component, Vue, Prop } from 'vue-property-decorator';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';

@Component({
    name: 'ProductVersionsTable',
})
export default class ProductVersionsTable extends Vue {
    @Prop({ required: true }) private config!: Record<string, any>;
    @Prop({ required: false }) private filteredData!: Record<string, any>;
    @Prop({ required: false }) private materialFilters!: Record<string, any>;
    @Prop({ required: false, default: null }) private pagination!: {
        current: number;
        pageSize: number;
        total: number;
    } | null;

    private loadingOverlay = new LoadingOverlayHelper(this, {});

    private get columns() {
        return this.config.columns;
    }

    private get paginationConfig() {
        if (this.pagination) {
            return {
                current: this.pagination.current,
                pageSize: this.pagination.pageSize,
                total: this.pagination.total,
                showSizeChanger: false,
            };
        }
        // For non-paginated tabs, use client-side pagination with explicit total
        return {
            pageSize: 6,
            total: this.filteredTableData.length,
        };
    }

    private get filteredTableData() {
        if (this.filteredData.length) {
            return this.filteredData;
        }

        return [];
    }

    private get tableData() {
        return this.config.tableData(); // this is a function that returns the data
    }

    private customRow(record: any) {
        return {
            on: {
                click: () => this.handleRowClick(record),
            },
        };
    }

    private handleRowClick(row: any) {
        this.$emit('rowClick', row);
    }

    private handleTableChange(pagination: any) {
        if (this.pagination) {
            this.$emit('paginationChange', { page: pagination.current, pageSize: pagination.pageSize });
        }
    }

    private async fetchProductVersions() {
        this.loadingOverlay.start();

        try {
            const result = await this.config.entityFetchEndpoint();
            // Emit pagination data if returned (for paginated endpoints)
            if (result?.total !== undefined) {
                this.$emit('paginationLoaded', { total: result.total });
            }
            this.$emit('setInitialTableData');
        } catch {
            this.$notification.error({
                message: this.$t('Error') as string,
                description: this.$t('An error occurred while fetching product versions') as string,
            });
        } finally {
            this.loadingOverlay.stop();
        }
    }

    private async mounted() {
        if (this.tableData.length) {
            this.$emit('setInitialTableData');
        } else {
            this.fetchProductVersions();
        }
    }
}
